import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setActiveTab, toggleLeftPanel, setToolSelection, setHeightForResults } from "../../actions/layoutActions";
import { startService,finishService } from "../../../gm3/actions/service";
import { clearFeatures } from '../../../gm3/actions/mapSource';
import { removeQuery } from '../../../gm3/actions/map';
import { runAction, setUiHint } from '../../../gm3/actions/ui';
import Loadable from "react-loadable";
import * as mapActions from '../../../gm3/actions/map';
import { NavItem, NavLink, Col, Nav, Row } from 'reactstrap';
const LoadableMapComponent = Loadable({
    loader: () => import("../MapComponent"),
    loading() {
        return <div><i className="fas fa-spinner fa-pulse"></i> Loading...</div>
    }
});
const LoadableRenderedResults = Loadable({
    loader: () => import("../RenderedResults"),
    loading() {
        return <div><i className="fas fa-spinner fa-pulse"></i> Loading...</div>
    }
});
const LoadableRenderedTableResults = Loadable({
    loader: () => import("../RenderedTableResults"),
    loading() {
        return <div><i className="fas fa-spinner fa-pulse"></i> Loading...</div>
    }
});

class Body extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: ["tools", "layers", "advancedtools"]//, "legend"]
        };
        this.setTab = this.setTab.bind(this);
        this.renderTabs = this.renderTabs.bind(this);
    }
    componentDidMount() {
        setTimeout(() => {
            if (this.getUrlVars()["Query"] !== undefined) {
                const val = this.getUrlVars()["Query"];
                this.props.actions.setActiveTab("search");
                this.props.actions.setToolSelection("search");
                this.props.actions.startService("search");
                setTimeout(() => {
                    document.querySelectorAll(".service-accord .__title")[0].click();
                    const input = document.querySelectorAll(".service-input.form-group input")[0];
                    input.value = val;
                    document.querySelectorAll(".tab-controls .btn-info")[0].click();
                    // basically do while loop. 
                    const wait = setInterval(() => {
                        if (this.props.query[this.props.order[0]].progress === "finished") {
                            document.querySelectorAll(".result-item-actions .btn-info")[1].click();
                            // sometimes pan to fails, snap will fix it. if pan worked, map wont update
                            setTimeout(() => { document.querySelectorAll(".result-item-actions .btn-info")[0].click(); }, 500);
                            clearInterval(wait);
                        }
                    }, 500);
                }, 250);
            }
            else {
                this.props.actions.setActiveTab("tools");
                this.props.actions.setToolSelection("identify");
                this.props.actions.startService("identify");
            }


        }, 500);
    }
    renderTabs() {
        return <Nav pills={true} fill={true} role="navigation">
            <NavItem onClick={(e) => { this.setTab(e, 'tools'); this.props.actions.setToolSelection("identify"); this.props.actions.startService("identify"); }}>
                <NavLink href="#" active={this.props.tool === 'identify'}>Identify</NavLink>
            </NavItem>
            <NavItem onClick={(e) => { this.setTab(e, 'tools'); this.props.actions.setToolSelection("search"); this.props.actions.startService("search"); }}>
                <NavLink href="#" active={this.props.tool === 'search'}>Search</NavLink>
            </NavItem>
            <NavItem className="mobile--hidden" onClick={(e) => { this.setTab(e, 'advancedtools'); this.props.actions.setToolSelection("select"); this.props.actions.startService("select"); }}>
                <NavLink href="#" active={this.props.tab === 'advancedtools'}>Tools</NavLink>
            </NavItem>
            <NavItem onClick={(e) => { this.setTab(e, 'layers'); this.props.actions.setToolSelection(""); }}>
                <NavLink href="#" active={this.props.tab === 'layers'}>Layers</NavLink>
            </NavItem>
        </Nav>
    }
    getClassName(type) {
        if (this.props.tab === type) {
            return "";
        } else {
            return "hide_container"
        }
    }
    getLeftPanelClassName() {
        if (!this.props.showLeftPanel) {
            return "left-panel-container hide_container";
        } else {
            return "col-sm-12 col-md-5 col-lg-3 left-panel-container";
        }
    }
    getRightPanelClassName() {
        if (this.props.showLeftPanel) {
            return "col-sm-12 col-md-7 col-lg-9 right-panel-container";
        } else {
            return "col-12 right-panel-container";
        }
    }
    showTable() {
        if (this.props.showTablePanel) {
            return (<Col lg="12" className="table-results"><LoadableRenderedTableResults app={this.props.app} /></Col>);
        } else {
            return null;
        }
    }
    clearSelectionFeatures() {
        this.props.actions.clearMap();
        this.props.actions.clearSelectionFeatures();
        this.props.actions.resetBuffer();
        this.props.actions.clearFeatures();
        this.props.actions.clearFeatures("results");
        this.props.actions.setActiveTab("tools");
        for (let key of this.props.query.order) {
            this.props.actions.removeQuery(key);
        }
        this.props.actions.setToolSelection("identify");
        this.props.actions.startService("identify");
        setTimeout(()=>{
            let ctx = document.getElementById('service-manager-form');
            if (ctx) {
                const height = ctx.clientHeight + this.getTop(ctx) + 150;
                this.props.actions.setHeightForResults(window.innerHeight - height);
            }
            this.forceUpdate();
        }, 200)

    }
    getMapClass() {
        if (this.props.showTablePanel) {
            return "col-lg-12 max-map-height";
        } else {
            return "col-12 height-100";
        }
    }
    getTop(ctx) {
        return window.scrollY + ctx.getBoundingClientRect().top; // Y
    }
    getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    }
    setTab(e, tab) {
        e.preventDefault();
        this.props.actions.setActiveTab(tab);
    }
    render() {
        return (
            <div className="body-container">
                <a href="#" className="btn btn-success mobile--only" id="toTop">Back to top</a>
                <div className="print-icon" id="print-preview">
                    {/* <i className="fas fa-print"></i> */}
                </div>
                <Row noGutters={true}>
                    <div className={this.getLeftPanelClassName()}>
                        <nav className="info-panel" role="navigation">
                            {this.renderTabs()}
                            <div className={this.props.tab !== "layers" ? "" : "hide_container"}>
                                <div className={(this.props.tool !== "search" && this.props.tool !== "identify") ? "btn-group advancedtools" : "hide_container"} >
                                    <button className={this.props.tool === "select" ? "btn btn-info tool active" : "btn btn-info"} onClick={
                                        () => {
                                            this.props.actions.setToolSelection("select");
                                            this.props.actions.startService("select");
                                        }}>Select</button>
                                    <button className={this.props.tool === "measure" ? "btn btn-info tool active" : "btn btn-info"} onClick={
                                        () => {
                                            this.props.actions.setToolSelection("measure");
                                            this.props.actions.startService("measure");
                                        }}>Measure</button>
                                </div>
                                <div className={this.props.tab !== "layers" ? "" : "hide_container"} id="tools-tab" />
                                <LoadableRenderedResults app={this.props.app} />
                            </div>
                            <div className={this.getClassName("layers")} id="layers-tab" />
                        </nav>
                    </div>
                    <div className={this.getRightPanelClassName()}>
                        <Row noGutters={true}>
                            <div className={this.getMapClass()}>
                                <div className="ol-control custom-print-tool" id="print_btn" title="Print Map" onClick={() => { this.props.actions.runAction(); }}>
                                    <button type="button">
                                        <i className="fa fa-print" aria-hidden="true" />
                                    </button>
                                </div>
                                <div className="ol-control custom-clear-tool" title="Reset Map" id="trash-btn" onClick={() => { this.clearSelectionFeatures() }}>
                                    <button type="button">
                                        <i className="fa fa-trash" aria-hidden="true" />
                                    </button>
                                </div>
                                <LoadableMapComponent app={this.props.app} />
                            </div>
                            {this.showTable()}
                        </Row>
                    </div>
                </Row>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        showLeftPanel: state.layout.showLeftPanel,
        showTablePanel: state.layout.showTablePanel,
        tab: state.layout.tab,
        tool: state.layout.tool,
        results: state.layout.results,
        hasResults: state.layout.hasResults,
        query: state.query,
        order: state.query.order
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        actions: {
            setActiveTab: (tab = "tools") => dispatch(setActiveTab(tab)),
            toggleLeftPanel: () => dispatch(toggleLeftPanel()),
            setToolSelection: (tool) => dispatch(setToolSelection(tool)),
            startService: (service) => dispatch(startService(service)),
            resetBuffer: () => { dispatch(mapActions.setSelectionBuffer(0)) },
            removeQuery: (queryId = "") => dispatch(removeQuery(queryId)),
            setUiHint: (str) => { dispatch(setUiHint(str)) },
            runAction: (toolname = "print") => { dispatch(runAction(toolname)); },
            clearMap: () => { dispatch(finishService()); },
            clearFeatures: (layer = "selection") => { dispatch(clearFeatures(layer)) },
            clearSelectionFeatures: () => { dispatch(mapActions.clearSelectionFeatures()) },
            setHeightForResults: (height) => dispatch(setHeightForResults(height))
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(Body);
